import React, { useState, useRef, useMemo, useEffect } from 'react';
import { getLocale, history, useIntl, useSelector } from 'umi';
import moment from 'moment';
import { cloneDeep } from 'lodash-es';
import { Bubble } from "tea-component";
import Filter from '@/pages/dashboard/components/NewFilter';
// import Notification from '@/pages/dashboard/components/Notification'
import RangePicker from '@/pages/home/components/RangePicker';
import {
  getRangeDateLength, setBtnPointLog
} from '@/pages/dashboard/utils/utils';
import { FORM_MAP } from '../../pages/comparison/_config/constants';
import { renderChurnLevel } from '../engagement/churnNightingaleAllFilter/filterList';
import { getDurationContrastDate } from './_utils';
import { useFilterData } from './hooks';
import { getDateDefault } from '../../utils/dateUtils';
import { filterValueType } from '../../components/NewFilter/_type';
/**
 *
 * @param props
 * @param props:filterConfirm 筛选器确认函数
 * @param props:filterReset 筛选器重置函数
 * @param props:setFilterLoading 筛选器loading设置，透传到筛选器组件内部，获取到筛选器列表时区等数据之后，设置为false，测试才可进行页面和组件中的接口调用
 * @param props:filterInit 初始化函数，会向外部传递初始化后的筛选器值
 * @returns
 */
const dateTypeMap: any = {
  date: 'Day',
  week: 'Week',
  month: 'Month',
  Day: 'date',
  Week: 'week',
  Month: 'month',
};

const NightingaleDateComparisonFilter = (props: any) => {
  const { buttonLogConfig, filterConfirm, filterReset, setFilterLoading, isHaveFilterSave, filterInit,
    openSticky = false, data, children, changeData, path, timeZone = 0 } = props;
  const { formatMessage } = useIntl();
  const seasonInfo = useSelector((state: any) =>
    // 初始可能为undefied,在此加兜底
    state?.dashboardSetting?.gameConfig?.season_info || { date: [], week: [], month: [] }
  );

  const rangeTimeDefualt = getDateDefault({ timeType: 'day', timeZone, startNum: 14, endNum: 1 });
  const [isReset, setReset] = useState(false);

  let rangeTimeDefualtInit = cloneDeep(rangeTimeDefualt);
  const contrastDateDefualt = [cloneDeep(rangeTimeDefualtInit[0]).subtract(14, 'day'), cloneDeep(rangeTimeDefualtInit[1]).subtract(14, 'day')];
  let contrastDateDefualtInit = cloneDeep(contrastDateDefualt);
  const filterState: any = history?.location?.state || { filterParams: '' };
  const urlFilterParams = typeof filterState === 'string' ? JSON.parse(filterState)?.filterParams : filterState?.filterParams;
  if (urlFilterParams?.filterValue) {
    const filterValue = urlFilterParams?.filterValue;
    const rangeTime = filterValue?.rangeTime;
    const timeType = urlFilterParams?.timeType;
    const rangeLength = getRangeDateLength(rangeTime[0], rangeTime[1], timeType);
    const contrastStartDate = (() => {
      const dateMap: any = {
        day: moment(rangeTime[0]).subtract(1, 'day').format('YYYY-MM-DD'),
        week: moment(rangeTime[0]).subtract(1, 'week').startOf('week').format('YYYY-MM-DD'),
        month: moment(rangeTime[0]).subtract(1, 'month').startOf('month').format('YYYY-MM-DD'),
      };

      return dateMap[timeType?.toLowerCase()];
    })();
    const contrastEndDate = (() => {
      const dateMap: any = {
        day: moment(contrastStartDate)?.add(rangeLength, 'day').format('YYYY-MM-DD'),
        week: moment(contrastStartDate)?.add(rangeLength, 'week').endOf('week').format('YYYY-MM-DD'),
        month: moment(contrastStartDate)?.add(rangeLength, 'month').endOf('month').format('YYYY-MM-DD'),
      };

      return dateMap[timeType?.toLowerCase()];
    })();
    contrastDateDefualtInit = [moment(contrastStartDate), moment(contrastEndDate)];
    rangeTimeDefualtInit = [moment(rangeTime[0]), moment(rangeTime[1])];
  }

  const [contrastDateDefualtVal, setContrastDateDefualtVal] = useState(contrastDateDefualtInit);
  const [rangeTimeDefualtVal, setRangeTimeDefualtVal] = useState(rangeTimeDefualtInit);
  const [formValue, setFormValue] = useState({
    // rangeTime: {
    //   type: 'date',
    //   value: rangeTimeDefualtInit,
    // },
    // contrastDate: {
    //   type: 'date',
    //   // value: [moment(DEFAULT_VALUE[FORM_MAP.CONTRAST_DATE][0]), moment(DEFAULT_VALUE[FORM_MAP.CONTRAST_DATE][1])],
    //   value: contrastDateDefualtInit,

    // },
  } as any);
  const { rangeTime, contrastDate, statisticDate_timeType } = useMemo(() => ({
    rangeTime: [formValue?.rangeTime?.value?.[0]?.format('YYYY-MM-DD'), formValue?.rangeTime?.value?.[1]?.format('YYYY-MM-DD')],
    contrastDate: [formValue?.contrastDate?.value?.[0]?.format('YYYY-MM-DD'), formValue?.contrastDate?.value?.[1]?.format('YYYY-MM-DD')],
    statisticDate_timeType: formValue?.rangeTime?.type
  }), [formValue]);
  // 最新的 filterValue 引用
  const filterValueRef = useRef(formValue);
  filterValueRef.current = formValue;

  // 统计日、对比日时间长度不一致提示逻辑
  const [statisticDateRange, setStatisticDateRange] = useState(getRangeDateLength(rangeTime?.[0], rangeTime?.[1], dateTypeMap[statisticDate_timeType]));
  const [contrastDateRange, setContrastDateRange] = useState(getRangeDateLength(contrastDate?.[0], contrastDate?.[1], dateTypeMap[statisticDate_timeType]));
  // const [statisticDateRange, setStatisticDateRange] = useState(getRangeDateLength(contrastDateDefualtVal?.[0], contrastDateDefualtVal?.[1], dateTypeMap[statisticDate_timeType]))
  // const [contrastDateRange, setContrastDateRange] = useState(getRangeDateLength(rangeTimeDefualtVal?.[0], rangeTimeDefualtVal?.[1], dateTypeMap[statisticDate_timeType]))
  const isSameRange = useMemo(() => statisticDateRange === contrastDateRange, [statisticDateRange, contrastDateRange]);

  useEffect(() => {
    // 不是继承跳转且初始化时设置长度对比
    if (!urlFilterParams?.filterValue && JSON.stringify(formValue) === '{}') {
      setStatisticDateRange(getRangeDateLength(rangeTimeDefualt?.[0], rangeTimeDefualt?.[1], dateTypeMap[statisticDate_timeType]));
      setContrastDateRange(getRangeDateLength(contrastDateDefualt?.[0], contrastDateDefualt?.[1], dateTypeMap[statisticDate_timeType]));
    }
  }, [rangeTimeDefualt, contrastDateDefualt]);

  const { loading, selector } = useFilterData(`/${path}`, 'daily', [], false, ['churn_level']);

  const { latestDate } = selector || {};

  const inputList = [
    {
      type: 'rangeDate',
      key: 'rangeTime',
      default: {
        type: 'date',
        // value:[moment().subtract(1, 'days'),moment().subtract(1, 'days')],
        value: rangeTimeDefualt,
      },
      className: getLocale() === 'zh-CN' ? 'search-border-cn' : 'search-border',
      rangePrefix: formatMessage({ id: 'comparison_analysis_date_comparison_statistics_date' }),
      componentDefault: {
        date: getDateDefault({ timeType: 'day', timeZone, startNum: 14, endNum: 1 }),
        week: getDateDefault({ timeType: 'week', timeZone, startNum: 6, endNum: 1 }),
        month: getDateDefault({ timeType: 'month', timeZone, startNum: 6, endNum: 1 }),
      },
      typeList: ['date'],
      extraShortcut: seasonInfo
    },
    {
      type: 'contrastDate',
      key: 'contrastDate',
      default: {
        type: 'date',
        value: contrastDateDefualtVal,
      },
      render: (props) => {
        // disabled用在筛选器保存的展示上
        const { onChange, value, disabled } = props;
        const rangePickerValue = isReset ? contrastDateDefualtVal : value?.value;

        return <Bubble
          className={"contrast-range-bubble"}
          visible={!isSameRange}
          escapeWithReference
          flipped={false}
          destroyOnClose={false}
          popupContainer={document.querySelector(".dateComparison")}
          content={formatMessage({ id: 'comparison_analysis_date_data_tips' })}
        >
          <div className={`search-item search-item-date ${!isSameRange ? 'contrast-range-wrapper' : ''}`} key={"contrastDate"}>
            <RangePicker
              value={rangePickerValue}
              showTips={!!isSameRange}
              tipsInfo={formatMessage({ id: 'comparison_analysis_date_select_tips' })}
              type={statisticDate_timeType}
              startOfTime="2010-01-01"
              className={getLocale() === 'zh-CN' ? 'search-border-cn' : 'search-border'}
              rangePrefix={formatMessage({ id: 'comparison_analysis_date_comparison_contrast_date' })}
              typeList={['date', 'week', 'month']}
              showSelectType
              startOfWeek={1}
              showShortcut={false}
              language={getLocale() === 'zh-CN' ? 'cn' : 'en'}
              timeTabDisabled
              disabled={disabled}
              onChange={(value: any) => {
                const rangeLength = getRangeDateLength(value?.[0], value?.[1], dateTypeMap[statisticDate_timeType]);
                const resultValue = {
                  ...filterValueRef.current,
                  [FORM_MAP.CONTRAST_DATE]: {
                    type: statisticDate_timeType,
                    value,
                  },
                };
                onChange('contrastDate', resultValue);
                setReset(false);
                setFormValue(resultValue);
                setContrastDateRange(rangeLength);
              }}
              onTimeChange={(value: any) => {
                const endDate = (() => {
                  const dateMap: any = {
                    date: moment(value?.[0])?.add(statisticDateRange, 'day').format('YYYY-MM-DD'),
                    week: moment(value?.[0])?.add(statisticDateRange, 'week').endOf('week').format('YYYY-MM-DD'),
                    month: moment(value?.[0])?.add(statisticDateRange, 'month').endOf('month').format('YYYY-MM-DD'),
                  };
                  return dateMap[statisticDate_timeType?.toLowerCase()];
                })();
                const resultValue = {
                  ...filterValueRef.current,
                  [FORM_MAP.CONTRAST_DATE]: {
                    type: statisticDate_timeType,
                    value: [moment(value?.[0]), moment(endDate)],
                  },
                };
                let startDate = value?.[0];
                if (['date', 'week'].includes(statisticDate_timeType?.toLowerCase())) {
                  startDate = moment(startDate.format('YYYY-MM-DD'));
                }
                const rangeLength = getRangeDateLength(startDate, endDate, dateTypeMap[statisticDate_timeType]);
                setReset(false);
                setFormValue(resultValue);
                setContrastDateRange(rangeLength);
              }}
            />
          </div>
        </Bubble>;
      },
    },
    {
      type: "zone",
      key: "zone",
      isUseConfig: true,
      // visible: 0,
      default: [
        "255"
      ]
    },
    {
      type: 'region',
      key: "region",
      isUseConfig: true,
      // visible: 1,
      default: {
        markets: ['255'],
        region_type: 'market'
      },
    },
    {
      type: "channel",
      key: "channel",
      isUseConfig: true,
      // visible: 0,
      default: [
        "255"
      ]
    },
    {
      type: "system",
      key: "system",
      isUseConfig: true,
      // visible: 1,
      default: [
        "255"
      ],
    },
    {
      type: "lang",
      key: "lang",
      isUseConfig: true,
      // visible: 0,
      default: ["255"]
    },
    {
      type: 'churn_level',
      key: 'churn_level',
      visible: data.haveChurnLevel ? 1 : 0,
      default: ['255'],
      render: renderChurnLevel
    },
  ];

  const contrastRange: any = useMemo(()=>({
    Day: getDateDefault({ timeType: 'day', timeZone, startNum: 28, endNum: 15 }),
    Week: getDateDefault({ timeType: 'week', timeZone, startNum: 12, endNum: 7 }),
    Month: getDateDefault({ timeType: 'month', timeZone, startNum: 12, endNum: 7 }),
  }), [timeZone]);

  const handleConfirm = (value: any) => {
    const fillterValue = {
      ...value,
      [FORM_MAP.STATISTIC_DATE]: [value[FORM_MAP.RANGE_TIME]?.value[0].format('YYYY-MM-DD'), value[FORM_MAP.RANGE_TIME]?.value[1].format('YYYY-MM-DD')],
      [FORM_MAP.CONTRAST_DATE]: [value[FORM_MAP.CONTRAST_DATE]?.value[0].format('YYYY-MM-DD'), value[FORM_MAP.CONTRAST_DATE]?.value[1].format('YYYY-MM-DD')],
      [FORM_MAP.STATISTIC_DATE_TYPE]: dateTypeMap[value[FORM_MAP.RANGE_TIME]?.type],
      selector,
      pagePath: path,
    };
    setBtnPointLog(buttonLogConfig, {
      ...value,
      [FORM_MAP.STATISTIC_DATE]: [value[FORM_MAP.RANGE_TIME]?.value[0].format('YYYY-MM-DD'), value[FORM_MAP.RANGE_TIME]?.value[1].format('YYYY-MM-DD')],
      [FORM_MAP.CONTRAST_DATE]: [value[FORM_MAP.CONTRAST_DATE]?.value[0].format('YYYY-MM-DD'), value[FORM_MAP.CONTRAST_DATE]?.value[1].format('YYYY-MM-DD')],
      [FORM_MAP.STATISTIC_DATE_TYPE]: dateTypeMap[value[FORM_MAP.RANGE_TIME]?.type]
    });
    setFormValue(value);
    filterConfirm?.(fillterValue);
    setReset(false);
  };

  const handleReset = (value: any) => {
    const filterValue = {
      ...value,
      [FORM_MAP.STATISTIC_DATE]: [rangeTimeDefualt?.[0].format('YYYY-MM-DD'), rangeTimeDefualt?.[1].format('YYYY-MM-DD')],
      [FORM_MAP.CONTRAST_DATE]: [contrastDateDefualt?.[0].format('YYYY-MM-DD'), contrastDateDefualt?.[1].format('YYYY-MM-DD')],
      [FORM_MAP.STATISTIC_DATE_TYPE]: dateTypeMap[value[FORM_MAP.RANGE_TIME]?.type],
      selector,
      pagePath: path,
    };
    setBtnPointLog(buttonLogConfig, {
      ...value,
      [FORM_MAP.STATISTIC_DATE]: [rangeTimeDefualt?.[0].format('YYYY-MM-DD'), rangeTimeDefualt?.[1].format('YYYY-MM-DD')],
      [FORM_MAP.CONTRAST_DATE]: [contrastDateDefualt?.[0].format('YYYY-MM-DD'), contrastDateDefualt?.[1].format('YYYY-MM-DD')],
      [FORM_MAP.STATISTIC_DATE_TYPE]: dateTypeMap[value[FORM_MAP.RANGE_TIME]?.type]
    }, true);

    setFormValue(value);
    setContrastDateDefualtVal(contrastDateDefualt);
    setRangeTimeDefualtVal(rangeTimeDefualt);
    setStatisticDateRange(getRangeDateLength(rangeTimeDefualt?.[0], rangeTimeDefualt?.[1], dateTypeMap[statisticDate_timeType]));
    setContrastDateRange(getRangeDateLength(contrastDateDefualt?.[0], contrastDateDefualt?.[1], dateTypeMap[statisticDate_timeType]));
    filterReset?.(filterValue);
    setReset(true);
  };

  // const handleInit = (defaultValue: any) => {
  //   const rangeTime = [defaultValue?.[FORM_MAP.RANGE_TIME]?.value[0].format('YYYY-MM-DD'), defaultValue[FORM_MAP.RANGE_TIME]?.value[1].format('YYYY-MM-DD')]
  //   const timeType = dateTypeMap[defaultValue?.[FORM_MAP.RANGE_TIME]?.type]

  //   const contrastDate = [defaultValue?.[FORM_MAP.CONTRAST_DATE]?.value[0].format('YYYY-MM-DD'), defaultValue[FORM_MAP.CONTRAST_DATE]?.value[1].format('YYYY-MM-DD')]

  //   setFilterLoading(false);
  //   setFormValue({
  //     ...defaultValue,
  //     // [FORM_MAP.CONTRAST_DATE]: {
  //     //   type: defaultValue?.[FORM_MAP.CONTRAST_DATE]?.type,
  //     //   value: [moment(), moment().add(13, 'day')],
  //     // },
  //   });


  //   filterInit({
  //     filterValue: {
  //       ...defaultValue,
  //       // [FORM_MAP.STATISTIC_DATE]: [defaultValue?.[FORM_MAP.RANGE_TIME]?.value[0].format('YYYY-MM-DD'), defaultValue[FORM_MAP.RANGE_TIME]?.value[1].format('YYYY-MM-DD')],
  //       [FORM_MAP.STATISTIC_DATE]: [rangeTimeDefualtVal?.[0].format('YYYY-MM-DD'), rangeTimeDefualtVal?.[1].format('YYYY-MM-DD')],
  //       [FORM_MAP.CONTRAST_DATE]: [contrastDateDefualtVal?.[0].format('YYYY-MM-DD'), contrastDateDefualtVal?.[1].format('YYYY-MM-DD')],
  //       [FORM_MAP.STATISTIC_DATE_TYPE]: timeType
  //     }
  //   });
  //   setReset(false)
  // };

  const handleInit = (defaultValue: any, inputList: any, isHaveExtendFilter: boolean) => {
    const rangeTime = [defaultValue?.[FORM_MAP.RANGE_TIME]?.value[0].format('YYYY-MM-DD'), defaultValue[FORM_MAP.RANGE_TIME]?.value[1].format('YYYY-MM-DD')];
    const timeType = dateTypeMap[defaultValue?.[FORM_MAP.RANGE_TIME]?.type];
    setFilterLoading(false);
    if (!isHaveExtendFilter) {
      setFormValue(defaultValue);
      filterInit?.({
        ...defaultValue,
        [FORM_MAP.STATISTIC_DATE]: [rangeTimeDefualtVal?.[0].format('YYYY-MM-DD'), rangeTimeDefualtVal?.[1].format('YYYY-MM-DD')],
        [FORM_MAP.CONTRAST_DATE]: [contrastDateDefualtVal?.[0].format('YYYY-MM-DD'), contrastDateDefualtVal?.[1].format('YYYY-MM-DD')],
        [FORM_MAP.STATISTIC_DATE_TYPE]: timeType,
        selector,
        pagePath: path,
      });
    } else {
      const contrastDate = getDurationContrastDate(defaultValue?.[FORM_MAP.RANGE_TIME]);
      const [start, end] = contrastDate?.value;

      setFormValue({
        ...defaultValue,
        [FORM_MAP.CONTRAST_DATE]: contrastDate,
      });
      filterInit({
        ...defaultValue,
        [FORM_MAP.STATISTIC_DATE]: rangeTime,
        [FORM_MAP.CONTRAST_DATE]: [start?.format('YYYY-MM-DD'), end?.format('YYYY-MM-DD')],
        [FORM_MAP.STATISTIC_DATE_TYPE]: timeType,
        selector
      });
    }
    setReset(false);
  };


  const handleChange = (key: string, inputValue: any, formVal: filterValueType) => {
    setFormValue({
      ...formVal,
      [key]: inputValue
    });
    if (key === FORM_MAP.RANGE_TIME) {
      const {
        type,
        value
      } = inputValue;

      const { contrastDate } = formVal || {};
      //  只有 statistic date 筛选器可以控制 contrast date 筛选器
      const rangeLength = getRangeDateLength(value?.[0]?.format('YYYY-MM-DD'), value?.[1]?.format('YYYY-MM-DD'), dateTypeMap[type]);
      const contrastRangeLength = (() => {
        if (type === contrastDate?.type) {
          return getRangeDateLength(
            contrastDate?.value?.[0]?.format('YYYY-MM-DD'),
            contrastDate?.value?.[1]?.format('YYYY-MM-DD'),
            dateTypeMap[type],
          );
        }
        return getRangeDateLength(
          contrastRange[dateTypeMap[type]][0],
          contrastRange[dateTypeMap[type]][1],
          dateTypeMap[type],
        );

      })();
      // 同步时间类型，重置对比日时间
      setFormValue({
        ...(formVal || {}),
        [FORM_MAP.RANGE_TIME]: {
          type,
          value
        },
        [FORM_MAP.CONTRAST_DATE]: {
          type,
          value: type === contrastDate?.type
            ? contrastDate?.value
            : [moment(contrastRange[dateTypeMap[type]][0]), moment(contrastRange[dateTypeMap[type]][1])],
        },
      });
      setContrastDateRange(contrastRangeLength);
      // 此处定时器为修复日期筛选器关闭动画消失的问题
      // setTimeout(() => {
      setStatisticDateRange(rangeLength);
      // })
      return;
    }
    if (key === FORM_MAP.CONTRAST_DATE) {
      const {
        type,
        value
      } = inputValue;
      const rangeLength = getRangeDateLength(value?.[0]?.format('YYYY-MM-DD'), value?.[1]?.format('YYYY-MM-DD'), dateTypeMap[type]);
      setFormValue({
        ...(formVal || {}),
        [FORM_MAP.CONTRAST_DATE]: {
          type,
          value
        },
      });
      setContrastDateRange(rangeLength);
      return;
    }
  };

  return (
    <span className={'dateComparison'}>
      <Filter
        path={path}
        openSticky={openSticky}
        value={formValue}
        latestDateType={''}
        inputList={inputList}
        onInit={handleInit}
        onConfirm={handleConfirm}
        outLatestDate={latestDate}
        outSelector={selector}
        onReset={handleReset}
        onChange={handleChange}
        confirmType={!isSameRange ? 'disabled' : ''}
        resetType={!isSameRange ? 'disabled' : ''}
        loading={loading}
        isHaveFilterSave={isHaveFilterSave}
      >
        {React.Children.map(children, (child: any) => React.cloneElement(
          child,
          {
            data,
            changeData,
          }
        ))}
      </Filter>
    </span>
  );
};

export default NightingaleDateComparisonFilter;
